"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrimeSwapSettings = exports.PRIME_REGISTRY_ADDRESS = void 0;
exports.mapSettings = mapSettings;
const PRIME_REGISTRY_ADDRESS = exports.PRIME_REGISTRY_ADDRESS = "0x0000000000000000000000000000000000000002";
const PrimeSwapSettings = exports.PrimeSwapSettings = {
  swapContracts: {
    folder: "Swap",
    file: "contracts",
    type: null
  },
  swapLocks: {
    folder: "Swap",
    file: "locks",
    type: null
  }
};
function mapSettings(response) {
  return Object.fromEntries(Object.entries(response).map(([key, val]) => [key, val.settings]));
}
//# sourceMappingURL=prime.js.map